var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "device-background" }, [
    _c("div", { attrs: { id: "deviceSelector" } }, [
      _c("div", { staticClass: "selector-container" }, [
        _c(
          "span",
          { staticClass: "title", attrs: { "aria-live": "assertive" } },
          [_vm._v(_vm._s(_vm.$gettext("Configuración de audio")))]
        ),
        _vm.isLoadingDevices
          ? _c("div", { staticClass: "loading-container" }, [
              _c("div", { staticClass: "spinner" }),
              _c("p", [
                _vm._v(_vm._s(_vm.$gettext("Cargando dispositivos..."))),
              ]),
            ])
          : _c("div", [
              _c("div", { staticClass: "select" }, [
                _c("label", { attrs: { for: "audioSource" } }, [
                  _vm._v(_vm._s(_vm.$gettext("Micrófono:"))),
                ]),
                _c("select", {
                  ref: "audioInputSelect",
                  attrs: { name: "audioInput", id: "audioSource" },
                  on: { change: _vm.setAudioIn },
                }),
              ]),
              _c("div", { staticClass: "select" }, [
                _c("label", { attrs: { for: "audioOutput" } }, [
                  _vm._v(_vm._s(_vm.$gettext("Altavoces:"))),
                ]),
                _c(
                  "select",
                  {
                    ref: "audioOutputSelect",
                    attrs: { name: "audioOutput", id: "audioOutput" },
                    on: { change: _vm.setAudioOut },
                  },
                  [_c("div", { staticClass: "speakers" })]
                ),
              ]),
            ]),
      ]),
      _c("div", { staticClass: "button-container" }, [
        _c(
          "button",
          {
            staticClass: "cancel",
            attrs: { name: "cancelDeviceSelection" },
            on: { click: _vm.closeModal },
          },
          [_vm._v(_vm._s(_vm.$gettext("Cancelar")) + " ")]
        ),
        _c(
          "button",
          {
            staticClass: "save-devices",
            class: { disabled: !_vm.hasDevices || _vm.isLoadingDevices },
            attrs: {
              disabled: !_vm.hasDevices || _vm.isLoadingDevices,
              title: !_vm.hasDevices
                ? _vm.$gettext(
                    "Necesitas micrófono y altavoces para hacer la llamada"
                  )
                : "",
              name: "startCall",
            },
            on: { click: _vm.startVideoCall },
          },
          [_vm._v(_vm._s(_vm.$gettext("Llamar")))]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }